<!-- Hero Start -->
<section class="main-slider" id="home">
  <ngb-carousel class="slides" [showNavigationArrows]="showNavigationArrows"
    [showNavigationIndicators]="showNavigationIndicators">
    <ng-template ngbSlide>
      <li class="bg-home bg-animation-left d-flex align-items-center"
        style="background-image:url('assets/banners/fe-rio-2.jpg')">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-7">
              <div class="title-heading position-relative mt-4" style="z-index: 1;">
                <h1 class="heading mb-3">{{ 'home.sliderOne.header' | translate }}</h1>
                <p class="para-desc"> {{ 'home.sliderOne.description' | translate}} </p>
                  <div class="watch-video mt-4 pt-2">
                      <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank" class="btn btn-primary"><i class="uil uil-shopping-basket"></i> {{ 'home.sliderOne.button' | translate}}</a>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ng-template>
    <ng-template ngbSlide>
      <li class="bg-home bg-animation-left d-flex align-items-center"
        style="background-image:url('assets/banners/fez-rio-1.jpg')">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-7">
              <div class="title-heading position-relative mt-4" style="z-index: 1;">
                <h1 class="heading mb-3">{{ 'home.sliderTwo.header' | translate }}</h1>
                <p class="para-desc">{{ 'home.sliderTwo.description' | translate }}</p>
                <div class="watch-video mt-4 pt-2">
                  <a routerLink="/program" class="btn btn-primary"><i class="uil uil-briefcase"></i> {{ 'home.sliderTwo.button' | translate }} </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ng-template>
    <ng-template ngbSlide>
      <li class="bg-home bg-animation-left d-flex align-items-center"
        style="background-image:url('assets/banners/copacabana.jpg')">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-7">
              <div class="title-heading position-relative mt-4" style="z-index: 1;">
                <h1 class="heading mb-3">{{ 'home.sliderThree.header' | translate }}</h1>
                <p class="para-desc">{{ 'home.sliderThree.description' | translate }}</p>
                  <div class="watch-video mt-4 pt-2">
                      <a routerLink="/tourism" class="btn btn-primary"><i class="uil uil-briefcase"></i>{{ 'home.sliderThree.button' | translate }}</a>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ng-template>
  </ngb-carousel>
</section>

<section class="py-5 border-bottom border-top">
    <div class="container">
        <app-clients-logo brand_class="col-lg-3 col-md-8 col-4 text-center"></app-clients-logo>
    </div>
    <!--end container-->
</section>
<!--end section-->
<!-- Hero End -->

<!-- Partners start -->
<!--<section class="section-two bg-light" id="bookroom">-->
<!--  <div class="container">-->
<!--    <div class="row justify-content-center">-->
<!--      <div class="col-lg-12">-->
<!--        <form class="p-4 shadow rounded">-->
<!--          <h4 class="mb-3">Compre Agora !</h4>-->
<!--          <div class="row text-start">-->
<!--            <div class="col-lg-3 col-md-6">-->
<!--              <div class="mb-3 mb-lg-0">-->
<!--                <label class="form-label"> Check in : </label>-->
<!--                <input type="text" class="form-control" name="picker" id="checkin" [(ngModel)]="checkin" mwlFlatpickr-->
<!--                [altInput]="true" [convertModelValue]="true">-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;end col&ndash;&gt;-->

<!--            <div class="col-lg-3 col-md-6">-->
<!--              <div class="mb-3 mb-lg-0">-->
<!--                <label class="form-label"> Check out : </label>-->
<!--                <input type="text" class="form-control" name="checkoutpicker" id="checkout" [(ngModel)]="checkout"-->
<!--                [altInput]="true" mwlFlatpickr [convertModelValue]="true">-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;end col&ndash;&gt;-->

<!--            <div class="col-lg-6">-->
<!--              <div class="row align-items-center">-->
<!--                <div class="col-md-4">-->
<!--                  <div class="mb-3 mb-lg-0">-->
<!--                    <label class="form-label">Adults : </label>-->
<!--                    <input type="number" min="0" autocomplete="off" id="adult" required="" class="form-control"-->
<!--                      placeholder="Adults :">-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash;end col&ndash;&gt;-->

<!--                <div class="col-md-4">-->
<!--                  <div class="mb-3 mb-lg-0">-->
<!--                    <label class="form-label">Children : </label>-->
<!--                    <input type="number" min="0" autocomplete="off" id="children" class="form-control"-->
<!--                      placeholder="Children :">-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash;end col&ndash;&gt;-->

<!--                <div class="col-md-4 mt-lg-4 pt-2 pt-lg-1">-->
<!--                  <div class="d-grid">-->
<!--                    <input type="submit" id="search" name="search" class="searchbtn btn btn-primary" value="Search">-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash;end col&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </form>-->
<!--      </div>-->
<!--      &lt;!&ndash;end col&ndash;&gt;-->
<!--    </div>-->
<!--    &lt;!&ndash;end row&ndash;&gt;-->
<!--  </div>-->
<!--  &lt;!&ndash;end container&ndash;&gt;-->
<!--</section>-->
<!--end section-->
<!-- Partners End -->

<section class="section">
  <div class="container">
      <div class="row justify-content-center">
          <div class="col-12 text-center">
              <div class="section-title mb-4 pb-2">
                  <h4 class="title mb-4">{{ 'home.event.header' | translate }}</h4>
                  <p class="text-muted para-desc mb-0 mx-auto"><span
                          class="text-primary fw-bold">{{ 'home.event.local' | translate }}</span> {{ 'home.event.descOne' | translate }}</p>
              </div>
          </div>
          <!--end col-->
      </div>
    <div class="row">

        <div class="col-lg-6 col-md-6 p-0 ps-md-3 pr-md-3">
            <div class="card map map-height-two rounded map-gray border-0">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.376008133829!2d-43.19061544354771!3d-22.973196787567844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9bd544483de141%3A0x2c3793aac4fb1d8a!2sSesc%20Copacabana!5e0!3m2!1spt-BR!2sbr!4v1738175891786!5m2!1spt-BR!2sbr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
      <div class="col-lg-6 col-md-6 p-0 ps-md-3 pr-md-3">
        <div class="card map map-height-two rounded map-gray border-0">
         <img src="assets/images/teatro-sesc.jpg" height="550" >
        </div>
      </div>
      <!--end col-->
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
  <!-- Contact End -->
</section>
<!--end section-->

<section class="section bg-cta" style="background: url('assets/images/copacabana2.jpg') center center;" id="cta">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title title-dark text-white mb-4">{{ 'home.ctaOne.header' | translate }}</h4>
                    <p class="text-white-50 para-dark para-desc mx-auto">{{ 'home.ctaOne.description' | translate }}</p>
                    <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank" class="btn btn-danger btn-lg"> {{ 'home.ctaOne.button' | translate }}
                    </a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<div class="position-relative">
    <div class="shape overflow-hidden text-light">
        <svg viewBox="0 0 2880 250" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M720 125L2160 0H2880V250H0V125H720Z" fill="currentColor"></path>
        </svg>
    </div>
</div>

<!-- Rooms Start -->
<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h4 class="title mb-4">{{ 'home.hotel.header' | translate }}</h4>
          <p class="text-muted para-desc mb-0 mx-auto"><span
                  class="text-primary fw-bold">{{ 'home.hotel.name' | translate }}</span>  {{ 'home.hotel.description' | translate }} </p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row">
      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card work-container work-modern rounded border-0 overflow-hidden">
          <div class="card-body p-0">
            <img src="assets/hotel/Copa-site-1140x480.jpg" class="img-fluid rounded" alt="work-image">
            <div class="overlay-work"></div>

            <div class="read_more bg-primary text-center rounded-circle">
              <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card work-container work-modern rounded border-0 overflow-hidden">
          <div class="card-body p-0">
            <img src="assets/hotel/DSC3746-1000x480.jpg" class="img-fluid rounded" alt="work-image">
            <div class="overlay-work"></div>

            <div class="read_more bg-primary text-center rounded-circle">
              <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card work-container work-modern rounded border-0 overflow-hidden">
          <div class="card-body p-0">
            <img src="assets/hotel/DSC3752-1000x480.jpg" class="img-fluid rounded" alt="work-image">
            <div class="overlay-work"></div>

            <div class="read_more bg-primary text-center rounded-circle">
              <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card work-container work-modern rounded border-0 overflow-hidden">
          <div class="card-body p-0">
            <img src="assets/hotel/DSC3775-1000x480.jpg" class="img-fluid rounded" alt="work-image">
            <div class="overlay-work"></div>

            <div class="read_more bg-primary text-center rounded-circle">
              <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card work-container work-modern rounded border-0 overflow-hidden">
          <div class="card-body p-0">
            <img src="assets/hotel/DSC_3225-1140x480.jpg" class="img-fluid rounded" alt="work-image">
            <div class="overlay-work"></div>

            <div class="read_more bg-primary text-center rounded-circle">
              <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card work-container work-modern rounded border-0 overflow-hidden">
          <div class="card-body p-0">
            <img src="assets/hotel/DSC_3136-1140x480.jpg" class="img-fluid rounded" alt="work-image">
            <div class="overlay-work"></div>

            <div class="read_more bg-primary text-center rounded-circle">
              <a href="javascript:void(0)" class="btn btn-primary btn-pills btn-sm btn-icon">
                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->


      <!--end col-->


      <!--end col-->

      <!--end col-->
    </div>
    <!--end row-->

    <div class="row justify-content-center">
      <div class="col-12 text-center mt-4 pt-2">
        <a routerLink="hotel" class="btn btn-primary">{{ 'home.hotel.button' | translate }} <i class="uil uil-angle-right-b"></i></a>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- Rooms End -->

<!-- CTA Start -->
<section class="section bg-cta" style="background: url('assets/images/copacabana.jpg') center center;" id="cta">
  <div class="bg-overlay"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title">
          <h4 class="title title-dark text-white mb-4">{{'home.ctaTwo.header'| translate}}</h4>
          <p class="text-white-50 para-dark para-desc mx-auto"> {{ 'home.ctaTwo.description' | translate }}</p>
          <a (click)="openModal(contentmodal)" href="javascript:void(0);"
            class="play-btn mt-4 video-play-icon">
            <i-feather name="play" class="fea icon-ex-md text-white title-dark"></i-feather>
          </a>
          <ng-template #contentmodal let-modal>
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <iframe width="780" height="450" src="https://www.youtube.com/embed/dAZaqpA9R-k?si=VERpemaeboV95W2-" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            </div>
          </ng-template>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- CTA End -->

<!-- Services Start -->
<!--<section class="section">-->
<!--  <div class="container pb-lg-4 mb-md-5 mb-4">-->
<!--    <div class="row justify-content-center">-->
<!--      <div class="col-12 text-center">-->
<!--        <div class="section-title mb-4 pb-2">-->
<!--          <h4 class="title mb-4">Best Services for you</h4>-->
<!--          <p class="text-muted para-desc mb-0 mx-auto">Start working with <span-->
<!--              class="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness,-->
<!--            drive traffic, connect.</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash;end col&ndash;&gt;-->
<!--    </div>-->
<!--    &lt;!&ndash;end row&ndash;&gt;-->

<!--    <app-services [servicesData]="servicesData" service_class="features feature-primary text-center mt-5"></app-services>-->
<!--  </div>-->
<!--  &lt;!&ndash;end container&ndash;&gt;-->
<!--</section>-->
<!--end section-->
<div class="position-relative">
  <div class="shape overflow-hidden text-light">
    <svg viewBox="0 0 2880 250" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M720 125L2160 0H2880V250H0V125H720Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- End services -->

<!-- News Start -->
<section class="section pt-5 pt-sm-0 pt-md-4 bg-light">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h4 class="title mb-4"> {{ 'home.tourism.header' | translate}}</h4>
          <p class="text-muted para-desc mx-auto mb-0">{{ 'home.tourism.description' | translate}} <span
              class="text-primary fw-bold">{{ 'home.tourism.descriptionTwo' | translate}} </span> {{ 'home.tourism.descriptionThree' | translate}}</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
    
    <app-blog [blogData]="blogData"></app-blog>
      <div class="row justify-content-center">
          <div class="col-12 text-center mt-4 pt-2">
              <a routerLink="/tourism" class="btn btn-primary">{{ 'home.tourism.button' | translate}}<i class="uil uil-angle-right-b"></i></a>
          </div>
          <!--end col-->
      </div>
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- Blog End -->

<!-- Client Start -->
<!--<section class="section" style="background: url('assets/images/hotel/bg05.jpg') center center;">-->
<!--  <div class="bg-overlay"></div>-->
<!--  <div class="container">-->
<!--    <div class="row justify-content-center">-->
<!--      <div class="col-lg-7 text-center">-->
<!--        &lt;!&ndash; <div id="owl-fade" class="owl-carousel owl-theme"> &ndash;&gt;-->
<!--        <owl-carousel-o id="customer-testi" [options]="customOptions">-->
<!--          <ng-template carouselSlide>-->
<!--            <div class="customer-testi text-center">-->
<!--              <p class="text-white-50 para-dark h6 fst-italic">" It seems that only fragments of the original text remain-->
<!--                in the Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said-->
<!--                to have originated in the 16th century. "</p>-->
<!--              <ul class="list-unstyled mb-0 mt-3">-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--              </ul>-->
<!--              <h6 class="text-light title-dark"> Thomas Israel </h6>-->
<!--              <img src="assets/images/client/01.jpg" class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"-->
<!--                alt="">-->
<!--            </div>-->
<!--            &lt;!&ndash;end customer testi&ndash;&gt;-->
<!--          </ng-template>-->
<!--          <ng-template carouselSlide>-->
<!--            <div class="customer-testi text-center">-->
<!--              <p class="text-white-50 para-dark h6 fst-italic">" The advantage of its Latin origin and the relative-->
<!--                meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the-->
<!--                viewer's attention from the layout. "</p>-->
<!--              <ul class="list-unstyled mb-0 mt-3">-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--              </ul>-->
<!--              <h6 class="text-light title-dark"> Carl Oliver </h6>-->
<!--              <img src="assets/images/client/02.jpg" class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"-->
<!--                alt="">-->
<!--            </div>-->
<!--            &lt;!&ndash;end customer testi&ndash;&gt;-->
<!--          </ng-template>-->
<!--          <ng-template carouselSlide>-->
<!--            <div class="customer-testi text-center">-->
<!--              <p class="text-white-50 para-dark h6 fst-italic">" There is now an abundance of readable dummy texts. These-->
<!--                are usually used when a text is required purely to fill a space. These alternatives to the classic Lorem-->
<!--                Ipsum texts are often amusing and tell short, funny or nonsensical stories. "</p>-->
<!--              <ul class="list-unstyled mb-0 mt-3">-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--              </ul>-->
<!--              <h6 class="text-light title-dark"> Barbara McIntosh </h6>-->
<!--              <img src="assets/images/client/03.jpg" class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"-->
<!--                alt="">-->
<!--            </div>-->
<!--            &lt;!&ndash;end customer testi&ndash;&gt;-->
<!--          </ng-template>-->
<!--          <ng-template carouselSlide>-->
<!--            <div class="customer-testi text-center">-->
<!--              <p class="text-white-50 para-dark h6 fst-italic">" According to most sources, Lorum Ipsum can be traced back-->
<!--                to a text composed by Cicero in 45 BC. Allegedly, a Latin scholar established the origin of the text by-->
<!--                compiling all the instances of the unusual word 'consectetur' he could find "</p>-->
<!--              <ul class="list-unstyled mb-0 mt-3">-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--              </ul>-->
<!--              <h6 class="text-light title-dark"> Christa Smith </h6>-->
<!--              <img src="assets/images/client/04.jpg" class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"-->
<!--                alt="">-->
<!--            </div>-->
<!--            &lt;!&ndash;end customer testi&ndash;&gt;-->
<!--          </ng-template>-->
<!--          <ng-template carouselSlide>-->
<!--            <div class="customer-testi text-center">-->
<!--              <p class="text-white-50 para-dark h6 fst-italic">" It seems that only fragments of the original text remain-->
<!--                in the Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said-->
<!--                to have originated in the 16th century. "</p>-->
<!--              <ul class="list-unstyled mb-0 mt-3">-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--              </ul>-->
<!--              <h6 class="text-light title-dark"> Dean Tolle </h6>-->
<!--              <img src="assets/images/client/05.jpg" class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"-->
<!--                alt="">-->
<!--            </div>-->
<!--            &lt;!&ndash;end customer testi&ndash;&gt;-->
<!--          </ng-template>-->
<!--          <ng-template carouselSlide>-->
<!--            <div class="customer-testi text-center">-->
<!--              <p class="text-white-50 para-dark h6 fst-italic">" It seems that only fragments of the original text remain-->
<!--                in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were-->
<!--                added or deleted at various positions within the text. "</p>-->
<!--              <ul class="list-unstyled mb-0 mt-3">-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
<!--              </ul>-->
<!--              <h6 class="text-light title-dark"> Jill Webb </h6>-->
<!--              <img src="assets/images/client/06.jpg" class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"-->
<!--                alt="">-->
<!--            </div>-->
<!--            &lt;!&ndash;end customer testi&ndash;&gt;-->
<!--          </ng-template>-->
<!--        </owl-carousel-o>-->
<!--        &lt;!&ndash; </div> &ndash;&gt;-->
<!--      </div>-->
<!--      &lt;!&ndash;end col&ndash;&gt;-->
<!--    </div>-->
<!--    &lt;!&ndash;end row&ndash;&gt;-->
<!--  </div>-->
<!--  &lt;!&ndash;end container&ndash;&gt;-->
<!--  &lt;!&ndash; Client End &ndash;&gt;-->
<!--</section>-->
<!--&lt;!&ndash; Client End &ndash;&gt;-->

<!-- Contact Start -->
<!--<section class="section">-->
<!--  <div class="container">-->
<!--    <div class="row">-->
<!--      <div class="col-lg-8 col-md-6 p-0 ps-md-3 pr-md-3">-->
<!--        <div class="card map map-height-two rounded map-gray border-0">-->
<!--          <iframe-->
<!--            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin"-->
<!--            style="border:0" class="rounded" allowfullscreen></iframe>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash;end col&ndash;&gt;-->

<!--      <div class="col-lg-4 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">-->
<!--        <div class="card rounded shadow border-0">-->
<!--          <div class="card-body py-5">-->
<!--            <h5 class="card-title">Get In Touch !</h5>-->

<!--            <div class="custom-form mt-4">-->
<!--              <div id="message"></div>-->
<!--              <form method="post" action="php/contact.php" name="contact-form" id="contact-form">-->
<!--                <div class="row">-->
<!--                  <div class="col-md-12">-->
<!--                    <div class="mb-3">-->
<!--                      <label class="form-label">Your Name <span class="text-danger">*</span></label>-->
<!--                      <div class="form-icon position-relative">-->
<!--                        <i-feather name="user" class="fea icon-sm icons"></i-feather>-->
<!--                        <input name="name" id="name" type="text" class="form-control ps-5" placeholder="First Name :">-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end col&ndash;&gt;-->
<!--                  <div class="col-md-12">-->
<!--                    <div class="mb-3">-->
<!--                      <label class="form-label">Your Email <span class="text-danger">*</span></label>-->
<!--                      <div class="form-icon position-relative">-->
<!--                        <i-feather name="mail" class="fea icon-sm icons"></i-feather>-->
<!--                        <input name="email" id="email" type="email" class="form-control ps-5"-->
<!--                          placeholder="Your email :">-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end col&ndash;&gt;-->
<!--                  <div class="col-md-12">-->
<!--                    <div class="mb-3">-->
<!--                      <label class="form-label">Comments</label>-->
<!--                      <div class="form-icon position-relative">-->
<!--                        <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>-->
<!--                        <textarea name="comments" id="comments" rows="4" class="form-control ps-5"-->
<!--                          placeholder="Your Message :"></textarea>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash;end row&ndash;&gt;-->
<!--                <div class="row">-->
<!--                  <div class="col-sm-12 text-center">-->
<!--                    <div class="d-grid">-->
<!--                      <input type="submit" id="submit" name="send" class="submitBnt btn btn-primary"-->
<!--                        value="Send Message">-->
<!--                      <div id="simple-msg"></div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;end col&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;end row&ndash;&gt;-->
<!--              </form>-->
<!--              &lt;!&ndash;end form&ndash;&gt;-->
<!--            </div>-->
<!--            &lt;!&ndash;end custom-form&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash;end col&ndash;&gt;-->
<!--    </div>-->
<!--    &lt;!&ndash;end row&ndash;&gt;-->
<!--  </div>-->
<!--  &lt;!&ndash;end container&ndash;&gt;-->
<!--  &lt;!&ndash; Contact End &ndash;&gt;-->
<!--</section>-->
<!--end section-->
<!-- News End -->

<section class="section bg-cta" style="background: url('assets/images/copacabana3.jpg') center center;" id="cta">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title title-dark text-white mb-4">{{'home.ctaThree.header' | translate }}</h4>
                    <p class="text-white-50 para-dark para-desc mx-auto">{{'home.ctaThree.description' | translate }}</p>
                    <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank"class="btn btn-danger btn-lg">{{'home.ctaThree.button' | translate }}
                    </a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>


<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
